export type BulkChoice = '1' | '0' | 'NA';

export function fillAnswersRow(length: number, choice: BulkChoice): string[] {
  if (length <= 0) {
    return [];
  }
  return Array.from({ length }, () => choice);
}
